import { render, staticRenderFns } from "./dyKeyboard.vue?vue&type=template&id=16b81270&scoped=true&"
import script from "./dyKeyboard.js?vue&type=script&lang=js&"
export * from "./dyKeyboard.js?vue&type=script&lang=js&"
import style0 from "./dyKeyboard.vue?vue&type=style&index=0&id=16b81270&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b81270",
  null
  
)

export default component.exports